import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class PrototypeCategoryProvider extends HttpRequest {
  constructor () {
    super(process.env.VUE_APP_MER_API)
  }

  getAll () {
    this.setHeader(getAuthToken())
    return this.get('/prototype-sub-categories')
  }

  getAllMapped () {
    this.setHeader(getAuthToken())
    return this.get('/prototype-sub-categories/mapped')
  }

  getOne (id) {
    this.setHeader(getAuthToken())
    return this.get(`/prototype-sub-categories/${id}`)
  }

  createOne (form) {
    this.setHeader(getAuthToken())
    return this.post('/prototype-sub-categories', form)
  }

  updateOne (id, form) {
    this.setHeader(getAuthToken())
    return this.post(`/prototype-sub-categories/${id}`, form)
  }

  deleteOne (id) {
    this.setHeader(getAuthToken())
    return this.get(`/prototype-sub-categories/${id}`)
  }
}

export default PrototypeCategoryProvider
